// extracted by mini-css-extract-plugin
module.exports = {"imageSelector":"IncisedStones_imageSelector__hwTYZ"};